module.exports = "<a class=\"dropdown-toggle\" (click)=\"login()\">Login</a>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/headerandnavigation/login/identitylogin.component.html
// module id = ./src/app/headerandnavigation/login/identitylogin.component.html
// module chunks = main